/** URL canonica del sito pubblico (senza slash finale). */
export const siteOrigin =
  (import.meta.env.VITE_SITE_URL ?? 'https://www.wyrdgrove.art').replace(
    /\/$/,
    ''
  )

export const siteName = 'Wyrd Grove'

/** Immagine Open Graph di default (path assoluto sul sito). */
export const defaultOgImagePath = '/avatar.png'

export function absoluteUrl(path = '') {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${siteOrigin}${normalized}`
}

export function absoluteOgImage(imagePath) {
  const path = imagePath?.startsWith('http')
    ? imagePath
    : imagePath
      ? absoluteUrl(imagePath)
      : absoluteUrl(defaultOgImagePath)
  return path
}
